import { AuthContext, type SignInPayload } from '@entities/auth';
import { useContext } from 'react';

export function useAuthSignIn() {
  const { signIn } = useContext(AuthContext);
  return (payload: SignInPayload) => signIn(payload);
}
